export default __webpack_public_path__ + "static/media/tomtom-banner.4326e402.jpg";